"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Implementation of visitor pattern for value descriptors. Default implementation
 * of visitor methods descents to members of actual node of value description tree.
 */

var RecursiveDescVisitor =
/*#__PURE__*/
function () {
  function RecursiveDescVisitor(defResult) {
    _classCallCheck(this, RecursiveDescVisitor);

    this.defResult = defResult;
    /**/
  }

  _createClass(RecursiveDescVisitor, [{
    key: "visitProp",
    value: function visitProp(propDesc) {
      return this.visitAny(propDesc);
    }
  }, {
    key: "visitOption",
    value: function visitOption(optDesc) {
      var r1 = this.visitAny(optDesc);
      var r2 = optDesc.base.acceptVisitor(this);
      return this.combine(r1, r2);
    }
  }, {
    key: "visitList",
    value: function visitList(listDesc) {
      var r1 = this.visitAny(listDesc);
      var r2 = listDesc.members.acceptVisitor(this);
      return this.combine(r1, r2);
    }
  }, {
    key: "visitSet",
    value: function visitSet(setDesc) {
      var r1 = this.visitAny(setDesc);
      var r2 = setDesc.members.acceptVisitor(this);
      return this.combine(r1, r2);
    }
  }, {
    key: "visitArray",
    value: function visitArray(arrayDesc) {
      var r1 = this.visitAny(arrayDesc);
      var r2 = arrayDesc.members.acceptVisitor(this);
      return this.combine(r1, r2);
    }
  }, {
    key: "visitMap",
    value: function visitMap(mapDesc) {
      var r1 = this.visitAny(mapDesc);
      var r2 = mapDesc.members.acceptVisitor(this);
      return this.combine(r1, r2);
    }
  }, {
    key: "visitFlagSet",
    value: function visitFlagSet(flagSetDesc) {
      var r1 = this.visitAny(flagSetDesc);
      return r1;
    }
  }, {
    key: "visitAlternative",
    value: function visitAlternative(altDesc) {
      var r1 = this.visitAny(altDesc);
      var r2 = altDesc.left.acceptVisitor(this);
      var r3 = altDesc.left.acceptVisitor(this);
      return this.combine(this.combine(r1, r2), r3);
    }
  }, {
    key: "visitObject",
    value: function visitObject(objectDesc) {
      var r = this.visitAny(objectDesc);
      return this.combine(r, this.visitDataDesc(objectDesc.data));
    }
  }, {
    key: "visitData",
    value: function visitData(dataDesc) {
      var r = this.visitAny(dataDesc);
      return this.combine(r, this.visitDataDesc(dataDesc.data));
    }
    /**
     * Traverses all properties of provided data description and visits them.
     * @param desc
     */

  }, {
    key: "visitDataDesc",
    value: function visitDataDesc(desc) {
      var r = this.defResult;

      var _arr = Object.keys(desc);

      for (var _i = 0; _i < _arr.length; _i++) {
        var k = _arr[_i];
        var v = desc[k];
        r = this.combine(r, this.visitObjectProperty(k, v));
      }

      return r;
    }
  }, {
    key: "visitObjectProperty",
    value: function visitObjectProperty(key, desc) {
      return desc.acceptVisitor(this);
    }
  }, {
    key: "visitAny",
    value: function visitAny(desc) {
      return this.defResult;
    }
  }, {
    key: "combine",
    value: function combine(r1, r2) {
      return r2;
    }
  }]);

  return RecursiveDescVisitor;
}();

exports.RecursiveDescVisitor = RecursiveDescVisitor;